import { createQRCode, createVCardQRCode } from '@desygner/ui-common-qrcode';
import GraphicCreator from './abstract/graphic';

const qrCodeAttributes = [
  'data-qrcode-type',
  'data-qrcode-data',
  'data-qrcode-options'
];

class QRCodeCreator extends GraphicCreator {
  static getAllowedAttributes = () => qrCodeAttributes;

  #addDataAttributes (element, { type, data, options }) {
    element.setAttribute('data-qrcode-type', type);
    element.setAttribute('data-qrcode-data', encodeURIComponent(typeof data === 'string' ? data : JSON.stringify(data)));
    element.setAttribute('data-qrcode-options', encodeURIComponent(JSON.stringify(options)));
  }

  #calculateSize () {
    return Math.min(this.canvas.contentW, this.canvas.contentH) * 0.3;
  }

  #centerCoordinate (size, dimension) {
    return (dimension - size) / 2;
  }

  #getAttribute () {
    const size = this.#calculateSize();

    return {
      x: this.#centerCoordinate(size, this.canvas.contentW),
      y: this.#centerCoordinate(size, this.canvas.contentH),
      width: size,
      height: size
    };
  }

  #createQrCodeElement (svg, { type, data, options }) {
    const attributes = this.#getAttribute();
    const element = this.canvas.addElement('sticker', attributes);

    element.classList.add('qrcode');

    this.trigger('', element.getAttribute('id'), data);
    const newElement = this.updateContent(element, { content: svg });
    this.#addDataAttributes(newElement, { type, data, options });

    return newElement.getAttribute('id');
  }

  #generateSvg ({ type, data, options }) {
    switch (type) {
      case 'url': return createQRCode(data, options);
      case 'vcard': return createVCardQRCode(data, options);
      default: throw new Error(`Unsupported QR code type: ${type}`);
    }
  }

  create ({ type, data, options, preview }) {
    const svg = this.#generateSvg({ type, data, options });
    if (preview) return svg;

    return svg ? this.#createQrCodeElement(svg, { type, data, options }) : null;
  }
}

/**
 * Facade API requires module.exports notation
 */
module.exports = QRCodeCreator;
